module.exports = __webpack_public_path__ + "img/hwGuide.9cd57d52.png";